import {
  TIPO_DOCUMENTO_ENUM,
  TipoDocumentoEnumType,
} from "api/Types/TipoDocumentoEnum"

export type FormatoDocumento = "PDF"

export interface ModalTypeDownloadDocumentProps {
  modalState: {
    show: boolean
    id: string | null | undefined
    serie: string | null
  }
  onHide: () => void
  showElements: {
    downloadPdf?: boolean
    downloadXml?: boolean
  }
  typeDocument: TipoDocumentoEnumType
}

export const getFormato = (formato: FormatoDocumento) => {
  switch (formato) {
    case "PDF":
      return "pdf"
    // todo: Activate when the XML download is available
    // case "XML":
    //   return "xml"
    default:
      return ""
  }
}

export const getNameFile = (tipoDocumento: TipoDocumentoEnumType) => {
  switch (tipoDocumento) {
    case TIPO_DOCUMENTO_ENUM.FACTURA:
      return "Factura"
    case TIPO_DOCUMENTO_ENUM.PEDIDO:
      return "Pedido"
    case TIPO_DOCUMENTO_ENUM.ALBARAN:
      return "Albarán"
    case TIPO_DOCUMENTO_ENUM.PRESUPUESTO:
      return "Presupuesto"
    default:
      return ""
  }
}
